import { render, staticRenderFns } from "./Rdp.vue?vue&type=template&id=fa0fe5c6&scoped=true&"
import script from "./Rdp.vue?vue&type=script&lang=js&"
export * from "./Rdp.vue?vue&type=script&lang=js&"
import style0 from "./Rdp.vue?vue&type=style&index=0&id=fa0fe5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0fe5c6",
  null
  
)

export default component.exports